(function() {
  'use strict';

  function positionDropdowns() {
    const headerWrapper = document.querySelector('.header-wrapper-container-nav-bar');
    if (!headerWrapper) return;

    const headerRect = headerWrapper.getBoundingClientRect();

    // Set CSS custom property for CSS fallback
    document.documentElement.style.setProperty('--header-nav-bottom', headerRect.bottom + 'px');

    // Only position fixed mega-menu elements (.menu-target) - not all dropdowns
    const dropdownTargets = document.querySelectorAll('.dropdown-target');
    dropdownTargets.forEach(dropdown => {
      // For fixed-positioned elements (menu-target), use viewport-relative bottom
      if (dropdown.classList.contains('menu-target')) {
        dropdown.style.top = headerRect.bottom + 'px';
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionDropdowns);
  } else {
    positionDropdowns();
  }

  // Recalculate on resize
  window.addEventListener('resize', positionDropdowns);

  // Observe for class changes (dropdown activation with show-from-bottom)
  const observer = new MutationObserver(positionDropdowns);
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    observer.observe(header, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();
